import { DeviceItem } from "@9amhealth/openapi";
import smartMeter from "src/ui/assets/images/scale_smart_meter.webp";
import withings from "src/ui/assets/images/scale_withings.webp";

const stepOnYourScaleImageUrlVar = "--step-on-your-scale-image-url";

const scaleImageDefault = `url(${withings})`;

const scaleImageMap: { readonly [key: string]: string } = {
  "Smart Meter SMC-LBS Weight Scale": `url(${smartMeter})`,
  "Smart Meter Teleweight": `url(${smartMeter})`,
  "Smart Meter BT004": `url(${smartMeter})`,
  "Impilo Transtek MioConnect Scale": `url(${withings})`,
  "Withings Body Pro 2 Weight Scale": `url(${withings})`,
  "Other Weight Scale": `url(${withings})`
};

const scaleImageSkuMap: { readonly [key: string]: string } = {
  "device:smartmeter:SMiS1.5-12C": `url(${smartMeter})`,
  "device:smartmeter:SMiS-12C": `url(${smartMeter})`,
  "device:withings:3700546711565": `url(${withings})`
};

const scaleImageSkuSet = new Set<string>(Object.keys(scaleImageSkuMap));

const getScaleImage = ({
  scales,
  skuDevices
}: {
  scales: DeviceItem[];
  skuDevices?: string[];
}) => {
  const selectedScale = scales.find((scale) =>
    Boolean(scaleImageMap[scale.model ?? ""])
  );
  if (selectedScale) {
    return scaleImageMap[selectedScale.model ?? ""];
  }

  if (skuDevices?.length) {
    return scaleImageSkuMap[skuDevices[0]];
  }

  // const selectedSkuModel =
  return scaleImageDefault;
};

export const stepOnYourScalePopupConstant = {
  stepOnYourScaleImageUrlVar,
  scaleImageDefault,
  getScaleImage,
  scaleImageSkuSet
};
